module.exports = {
  i18n: {
    defaultLocale: 'en',
    locales: ['en', 'ru'],
    localeDetection: false
  },
  react: {
    useSuspense: true
    // wait: true
  },
  /** To avoid issues when deploying to some paas (vercel...) */
  reloadOnPrerender: process.env.NODE_ENV === 'development'
}
